module.exports = __webpack_public_path__ + "img/eye.352b2010.svg";